<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import TripleDES from "@/utils/lib/crypto.js";
export default {
  name: "App",
  data() {
    return {};
  },
  created() {
    let version = this.get_ios_version();

    console.log("version", version);
    if (version == 12) {
      this.$dialog({
        message: "如您iPhone手机当前系统版本为12，请升级手机系统版本！",
        confirmButtonText: "是",
        cancelButtonText: "否",
      });
    }

    // 判断是否是微信浏览器
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      console.log("是微信浏览器");
      // this.$cookie.get("openid") === null && this.$;
      localStorage.setItem("WX_VERSION", 1);
    } else {
      console.log("非微信浏览器");
      localStorage.setItem("WX_VERSION", 0);
    }

    // 刷新token
    this.bus.$on("saveTokenHandle", ($event, loginWay) => {
      console.log("保存状态");
      console.log("$event", $event, loginWay);

      // 刷新登录之后token
      if (loginWay == 0) {
        let cookieObjByUserid = {
          userguid: $event.userguid,
          token: $event.token,
        };

        let data = TripleDES.encode("token", cookieObjByUserid);
        this.$cookie.set("cookieObjByUserid", JSON.stringify(data), 4);
      } else if (loginWay == 1) {
        this.$store.commit("changeSomeThing/setLoginWay", 1);
        let cookieObjByWx = {
          userguid: $event.userguid,
          token: $event.token,
        };
         
        
        let data = TripleDES.encode("token", cookieObjByWx);
        this.$cookie.set("cookieObjByWx", JSON.stringify(data), 4);
      }

      this.getPremission($event, loginWay);
    });
  },
  methods: {
    get_ios_version() {
      // 获取iPhone手机系统版本号
      var ua = navigator.userAgent.toLowerCase();
      var version = null;
      if (ua.indexOf("like mac os x") > 0) {
        var reg = /os [\d._]+/gi;
        var v_info = ua.match(reg);
        version = (v_info + "").replace(/[^0-9|_.]/gi, "").replace(/_/gi, "."); // 得到版本号9.3.2或者9.0
        version = parseInt(version.split(".")[0]); // 得到版本号第一位
      }
      return version;
    },
    // 刷新token
    getPremission(resp, loginWay) {
      this.$store.commit("user/setUserId", resp.userid);
      this.$store.commit("user/setUserGuid", resp.userguid);
      this.$store.commit("user/setRealName", resp.realname);
      this.$store.commit("user/setToken", resp.token);
      this.$store.commit("user/setMobileNum", resp.mobilenum);
      this.$store.commit("user/setAccountType", resp.accounttype);
      this.$store.commit("user/setPermission", resp.permission);
      this.$store.commit("user/setAccountStatus", resp.accountstatus);
      this.$store.commit("user/setShowMsg", resp.showmsg);
      // if (loginWay == 0) {
      //   this.$store.commit("user/setWxOpenId", "");
      // } else {
      //   this.$store.commit("user/setWxOpenId", resp.wxopenid);
      // }
      this.$store.commit("user/setWxOpenId", resp.wxopenid);
      this.$store.commit("user/setWxUnionId", resp.wxunionid);
      this.$store.commit("user/setWxgenerateId", resp.wxgenerateid);
      this.$store.commit("user/setMallVer", resp.mallver);
      this.$store.commit("user/setIsAccEdit", resp.isallowedituserid);
      this.$store.commit("user/setMaxOpenNum", resp.maxopendocnum);
      this.$store.commit("user/setOpenNum", resp.opendocnum);
      this.$store.commit("user/setMaxToken", resp.maxtokens)
      if (resp.permission != null && resp.permission.length > 0) {
        let items = [];
        resp.permission.forEach((item) => {
          items.push(item.f);
        });
        this.$store.commit("user/setPermissionArray", items);
      }

      sessionStorage.setItem("userId", resp.userid);
      
      localStorage.setItem("userguid", resp.userguid);
      sessionStorage.setItem("token", resp.token);
      sessionStorage.setItem("phone", resp.mobilenum);
      sessionStorage.setItem("type", resp.accounttype);
      sessionStorage.setItem("p", JSON.stringify(resp.permission));
      sessionStorage.setItem(
        "permissionArray",
        JSON.stringify(this.$store.state.user.permissionArray)
      );
      sessionStorage.setItem("accountstatus", resp.accountstatus);
      sessionStorage.setItem("showmsg", resp.showmsg);
      // if (loginWay == 0) {
      //   sessionStorage.setItem("wxopenid", "");
      // } else {
      //   sessionStorage.setItem("wxopenid", resp.wxopenid);
      // }
      sessionStorage.setItem("wxopenid", resp.wxopenid);
      sessionStorage.setItem("wxunionid", resp.wxunionid);
      sessionStorage.setItem("wxgenerateid", resp.wxgenerateid);
      sessionStorage.setItem("mallver", resp.mallver);
      sessionStorage.setItem("isaccedit", resp.isallowedituserid);
      sessionStorage.setItem("maxopennum", resp.maxopendocnum);
      sessionStorage.setItem("opennum", resp.opendocnum);
      sessionStorage.setItem("maxtokens", resp.maxtokens);

      let cookieObj = {
        userId: resp.userid,
        userguid: resp.userguid,
        realname: resp.realname,
        token: resp.token,
        phone: resp.mobilenum,
        accounttype: resp.accounttype,
        permission: resp.permission,
        accountstatus: resp.accountstatus,
        showmsg: resp.showmsg,
        permissionArray: this.$store.state.user.permissionArray,
        wxunionid: resp.wxunionid,
        wxopenid:  resp.wxopenid,
        wxgenerateid: resp.wxgenerateid,
        mallver: resp.mallver,
        isaccedit:resp.isallowedituserid,
        maxopennum:resp.maxopendocnum,
        opennum: resp.opendocnum,
        maxtokens:resp.maxtokens
      };

      let data = TripleDES.encode("token", cookieObj);
      this.$cookie.set("cookieObj", JSON.stringify(data), 4);
    },
  },
  watch: {
    $route: {
      handler(val, oldval) {
        //更新菜单导航选中项目
        console.log("监听路由的变化", val, oldval);
        if (val.name === "NewFiles") {
          this.$store.commit("commonSearchData/changeActiveName", "a");
          localStorage.setItem("selectedId", "a");
          this.$store.commit("changeVersion/setChangeFlagWord", "地方版");
          localStorage.setItem("changeFlagWord", "地方版");
          this.$store.commit("changeVersion/setChangeFlag", false);
          localStorage.setItem("changeFlag", false);
        } else if (val.name === "NewFilesD") {
          this.$store.commit("commonSearchData/changeActiveName", "a");
          localStorage.setItem("selectedId", "a");
          this.$store.commit("changeVersion/setChangeFlagWord", "全国版");
          localStorage.setItem("changeFlagWord", "全国版");
          this.$store.commit("changeVersion/setChangeFlag", true);
          localStorage.setItem("changeFlag", true);
        } else if (val.name === "newSearchEngine") {
          this.$store.commit("commonSearchData/changeActiveName", "b");
          localStorage.setItem("selectedId", "b");
          this.$store.commit("changeVersion/setChangeFlagWord", "地方版");
          localStorage.setItem("changeFlagWord", "地方版");
          this.$store.commit("changeVersion/setChangeFlag", false);
          localStorage.setItem("changeFlag", false);
        } else if (val.name === "SearchEngine") {
          this.$store.commit("commonSearchData/changeActiveName", "b");
          localStorage.setItem("selectedId", "b");
          this.$store.commit("changeVersion/setChangeFlagWord", "地方版");
          localStorage.setItem("changeFlagWord", "地方版");
          this.$store.commit("changeVersion/setChangeFlag", false);
          localStorage.setItem("changeFlag", false);
        } else if (val.name === "SearchEngineD") {
          this.$store.commit("commonSearchData/changeActiveName", "b");
          localStorage.setItem("selectedId", "b");
          this.$store.commit("changeVersion/setChangeFlagWord", "全国版");
          localStorage.setItem("changeFlagWord", "全国版");
          this.$store.commit("changeVersion/setChangeFlag", true);
          localStorage.setItem("changeFlag", true);
        } else if (val.name === "Smartcloud") {
          if (this.$store.state.changeVersion.changeWord === "全国版") {
            this.$store.commit("changeVersion/setChangeFlag", true);
          }
          localStorage.setItem("selectedId", "c");
          this.$store.commit("commonSearchData/changeActiveName", "c");
        } else if (val.name === "ImportantClause") {
          if (this.$store.state.changeVersion.changeWord === "全国版") {
            this.$store.commit("changeVersion/setChangeFlag", true);
          }
          localStorage.setItem("selectedId", "g");
          this.$store.commit("commonSearchData/changeActiveName", "g");
        } else if (val.name === "OnlineMall") {
          if (this.$store.state.changeVersion.changeWord === "全国版") {
            this.$store.commit("changeVersion/setChangeFlag", true);
          }
          localStorage.setItem("selectedId", "d");
          this.$store.commit("commonSearchData/changeActiveName", "d");
        } else if (val.name === "Usermanual") {
          if (this.$store.state.changeVersion.changeWord === "全国版") {
            this.$store.commit("changeVersion/setChangeFlag", true);
          }
          localStorage.setItem("selectedId", "e");
          this.$store.commit("commonSearchData/changeActiveName", "e");
        } else if (val.name === "PersonalCenter") {
          if (this.$store.state.changeVersion.changeWord === "全国版") {
            this.$store.commit("changeVersion/setChangeFlag", true);
          }
          localStorage.setItem("selectedId", "h");
          this.$store.commit("commonSearchData/changeActiveName", "h");
        } else if (val.name === "VideoList") {
          if (this.$store.state.changeVersion.changeWord === "全国版") {
            this.$store.commit("changeVersion/setChangeFlag", true);
          }
          localStorage.setItem("selectedId", "f");
          this.$store.commit("commonSearchData/changeActiveName", "f");
        } else if (val.name === "Answer") {
          if (this.$store.state.changeVersion.changeWord === "全国版") {
            this.$store.commit("changeVersion/setChangeFlag", true);
          }
          localStorage.setItem("selectedId", "z");
          this.$store.commit("commonSearchData/changeActiveName", "z");
        } else if (val.name === "ExclusiveInfo") {
          this.$store.commit("changeVersion/setChangeFlag", false);
          localStorage.setItem("changeFlag", false);
          localStorage.setItem("selectedId", "k");
          this.$store.commit("commonSearchData/changeActiveName", "k");
        } else if (val.name === "JudgeCase") {
          this.$store.commit("changeVersion/setChangeFlag", false);
          localStorage.setItem("changeFlag", false);
          localStorage.setItem("selectedId", "m")
          this.$store.commit("commonSearchData/changeActiveName", "m");
        } else if(val.name === "TaxCase") {
          this.$store.commit("changeVersion/setChangeFlag", false);
          localStorage.setItem("changeFlag", false);
          localStorage.setItem("selectedId", "n")
          this.$store.commit("commonSearchData/changeActiveName", "n");
        } else if(val.name === "ExpertAnswer") {
          this.$store.commit("changeVersion/setChangeFlag", false);
          localStorage.setItem("changeFlag", false);
          localStorage.setItem("selectedId", "p")
          this.$store.commit("commonSearchData/changeActiveName", "p");
        } else if(val.name === "PolicyMate") {
          this.$store.commit("changeVersion/setChangeFlag", false);
          localStorage.setItem("changeFlag", false);
          localStorage.setItem("selectedId", "r")
          this.$store.commit("commonSearchData/changeActiveName", "r");
        } else if(val.name === "chatai") {
          this.$store.commit("changeVersion/setChangeFlag", false);
          localStorage.setItem("changeFlag", false);
          localStorage.setItem("selectedId", "ch")
          this.$store.commit("commonSearchData/changeActiveName", "ch");
        }else if(val.name === "TaxForm") {
          this.$store.commit("changeVersion/setChangeFlag", false);
          localStorage.setItem("changeFlag", false);
          localStorage.setItem("selectedId", "q")
          this.$store.commit("commonSearchData/changeActiveName", "q");
        } else if(val.name === "SharePage") {
          localStorage.setItem("changeFlag", false);
        }
        else {
          // this.$router.push('index')
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
};
</script>
<style lang="less">
@import "~@/styles/index.less";

html,
body,
#app {
  width: 100%;
  height: 100%;
  font-size: 14px;
  background: #fff;
}
</style>
